var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-6 h-6 flex flex-col items-center justify-center rounded-sm mr-1 text-sm",class:{
    'bg-level-l': _vm.level === 'l' || _vm.level === 1,
    'bg-level-m': _vm.level === 'm' || _vm.level === 2,
    'bg-level-h': _vm.level === 'h' || _vm.level === 3,
    'bg-gray-400': _vm.level === 'n' || _vm.level === 0,
  },attrs:{"title":_vm.severityMap[_vm.level]},on:{"click":function($event){return _vm.$emit('on_click')}}},[_c('Icon',{staticClass:"text-light w-4 h-4",attrs:{"icon":"Events"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }